var map = {
	".": [
		36724,
		9
	],
	"./": [
		36724,
		9
	],
	"./App": [
		49816,
		9
	],
	"./App.css": [
		44050,
		9
	],
	"./App.test": [
		20477,
		9,
		2012,
		6004,
		477
	],
	"./App.test.tsx": [
		20477,
		9,
		2012,
		6004,
		477
	],
	"./App.tsx": [
		49816,
		9
	],
	"./assets/background.jpeg": [
		31477,
		1,
		1477
	],
	"./assets/city-road.svg": [
		36786,
		1,
		6786
	],
	"./assets/doctor.svg": [
		77519,
		1,
		7519
	],
	"./assets/efm_segment.svg": [
		49214,
		1,
		9214
	],
	"./assets/persion.svg": [
		87544,
		1,
		7544
	],
	"./assets/reply.svg": [
		36378,
		1,
		6378
	],
	"./assets/ticker.svg": [
		56156,
		1,
		6156
	],
	"./component/PagePreCheck": [
		5272,
		9
	],
	"./component/PagePreCheck.tsx": [
		5272,
		9
	],
	"./component/biz/AdmissionInfoModal": [
		93840,
		9,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		370
	],
	"./component/biz/AdmissionInfoModal.tsx": [
		93840,
		9,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		370
	],
	"./component/biz/CopyLabelingBoardModal": [
		45708,
		9,
		8424,
		6497,
		7690,
		3913,
		2513,
		5708,
		1423
	],
	"./component/biz/CopyLabelingBoardModal.tsx": [
		45708,
		9,
		8424,
		6497,
		7690,
		3913,
		2513,
		5708,
		1423
	],
	"./component/biz/EfmChart": [
		97168,
		9,
		7168
	],
	"./component/biz/EfmChart.tsx": [
		97168,
		9,
		7168
	],
	"./component/biz/EfmTimeOverviewModal": [
		94045,
		9,
		8424,
		7690,
		3913,
		9073,
		9923,
		4045,
		6560
	],
	"./component/biz/EfmTimeOverviewModal.tsx": [
		94045,
		9,
		8424,
		7690,
		3913,
		9073,
		9923,
		4045,
		6560
	],
	"./component/biz/EfmTimeSimplifiedModal": [
		76888,
		9,
		7690,
		3913,
		9073,
		6089
	],
	"./component/biz/EfmTimeSimplifiedModal.tsx": [
		76888,
		9,
		7690,
		3913,
		9073,
		6089
	],
	"./component/biz/LabelerWorkbenchAudited": [
		73760,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		3760
	],
	"./component/biz/LabelerWorkbenchAudited.tsx": [
		73760,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		3760
	],
	"./component/biz/LabelerWorkbenchLabeling": [
		65614,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		7332,
		3840,
		5614
	],
	"./component/biz/LabelerWorkbenchLabeling.tsx": [
		65614,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		7332,
		3840,
		5614
	],
	"./component/biz/LabelerWorkbenchNotReadyForAudit": [
		49902,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		4073,
		3840,
		9902,
		460
	],
	"./component/biz/LabelerWorkbenchNotReadyForAudit.tsx": [
		49902,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		4073,
		3840,
		9902,
		460
	],
	"./component/biz/LabelerWorkbenchReadyForAudit": [
		6673,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		3840,
		6673
	],
	"./component/biz/LabelerWorkbenchReadyForAudit.tsx": [
		6673,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		3840,
		6673
	],
	"./component/biz/LabelerWorkbenchWaittingAudit": [
		25062,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		5062
	],
	"./component/biz/LabelerWorkbenchWaittingAudit.tsx": [
		25062,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		5062
	],
	"./component/biz/LabelingBoard": [
		85586,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		7914,
		8831,
		9005,
		7692,
		6766,
		3945,
		3840,
		5586,
		6978
	],
	"./component/biz/LabelingBoard.module.css": [
		80476,
		9,
		476
	],
	"./component/biz/LabelingBoard.tsx": [
		85586,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		7914,
		8831,
		9005,
		7692,
		6766,
		3945,
		3840,
		5586,
		6978
	],
	"./component/biz/LabelingBoardChartView": [
		49279,
		9,
		9279
	],
	"./component/biz/LabelingBoardChartView.tsx": [
		49279,
		9,
		9279
	],
	"./component/biz/LabelingDiff": [
		79221,
		9,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		3840,
		6804,
		4597
	],
	"./component/biz/LabelingDiff.tsx": [
		79221,
		9,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		3840,
		6804,
		4597
	],
	"./component/biz/LabelingTaskHistoryModal": [
		95880,
		9,
		7690,
		3913,
		5529
	],
	"./component/biz/LabelingTaskHistoryModal.tsx": [
		95880,
		9,
		7690,
		3913,
		5529
	],
	"./component/biz/MaterialBoard": [
		38117,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		8117,
		4121
	],
	"./component/biz/MaterialBoard.module.css": [
		60021,
		9,
		21
	],
	"./component/biz/MaterialBoard.tsx": [
		38117,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		8117,
		4121
	],
	"./component/biz/MaterialChart": [
		65529,
		9,
		7910
	],
	"./component/biz/MaterialChart.tsx": [
		65529,
		9,
		7910
	],
	"./component/biz/MaterialDraft": [
		24628,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		4628,
		6856
	],
	"./component/biz/MaterialDraft.module.css": [
		99894,
		9,
		9894
	],
	"./component/biz/MaterialDraft.tsx": [
		24628,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		4628,
		6856
	],
	"./component/biz/MaterialInfoModal": [
		92842,
		9,
		7690,
		3913,
		8839
	],
	"./component/biz/MaterialInfoModal.tsx": [
		92842,
		9,
		7690,
		3913,
		8839
	],
	"./component/biz/MaterialRepositorySelector": [
		19918,
		9,
		9212,
		8424,
		6497,
		9073,
		9918
	],
	"./component/biz/MaterialRepositorySelector.tsx": [
		19918,
		9,
		9212,
		8424,
		6497,
		9073,
		9918
	],
	"./component/biz/ResearchAndDataGroupAndLabelSchemeSelector": [
		31568,
		9,
		9212,
		8424,
		6497,
		9073,
		1568
	],
	"./component/biz/ResearchAndDataGroupAndLabelSchemeSelector.tsx": [
		31568,
		9,
		9212,
		8424,
		6497,
		9073,
		1568
	],
	"./component/biz/ResearchAndDataGroupSelector": [
		79990,
		9,
		9212,
		8424,
		6497,
		9073,
		9990
	],
	"./component/biz/ResearchAndDataGroupSelector.tsx": [
		79990,
		9,
		9212,
		8424,
		6497,
		9073,
		9990
	],
	"./component/biz/ReviewerWorkbenchNotReviewed": [
		20206,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		3840,
		206
	],
	"./component/biz/ReviewerWorkbenchNotReviewed.tsx": [
		20206,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		3840,
		206
	],
	"./component/biz/ReviewerWorkbenchOthersWaitingAudit": [
		57055,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		9436
	],
	"./component/biz/ReviewerWorkbenchOthersWaitingAudit.tsx": [
		57055,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		9436
	],
	"./component/biz/ReviewerWorkbenchReviewed": [
		63771,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		6048,
		3840,
		3771,
		8079
	],
	"./component/biz/ReviewerWorkbenchReviewed.tsx": [
		63771,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		6048,
		3840,
		3771,
		8079
	],
	"./component/biz/UnlimitedResearchAndDataGroupAndLabelSchemeSelector": [
		98403,
		9,
		9212,
		8424,
		6497,
		9073,
		8403
	],
	"./component/biz/UnlimitedResearchAndDataGroupAndLabelSchemeSelector.tsx": [
		98403,
		9,
		9212,
		8424,
		6497,
		9073,
		8403
	],
	"./component/form/FormModal": [
		60834,
		9,
		9212,
		7690,
		3913,
		834
	],
	"./component/form/FormModal.tsx": [
		60834,
		9,
		9212,
		7690,
		3913,
		834
	],
	"./component/form/OptionalItem": [
		72982,
		9,
		9212,
		2513,
		2982
	],
	"./component/form/OptionalItem.tsx": [
		72982,
		9,
		9212,
		2513,
		2982
	],
	"./component/form/SchemaForm": [
		71816,
		9,
		5213,
		6371,
		2513,
		4561,
		7914,
		9434
	],
	"./component/form/SchemaForm.tsx": [
		71816,
		9,
		5213,
		6371,
		2513,
		4561,
		7914,
		9434
	],
	"./component/form/SearchForm": [
		66225,
		9,
		9212,
		6225
	],
	"./component/form/SearchForm.tsx": [
		66225,
		9,
		9212,
		6225
	],
	"./component/form/Selector": [
		25452,
		9,
		8424,
		6497,
		1757
	],
	"./component/form/Selector.tsx": [
		25452,
		9,
		8424,
		6497,
		1757
	],
	"./component/form/formItemLayout": [
		90104,
		9,
		104
	],
	"./component/form/formItemLayout.js": [
		90104,
		9,
		104
	],
	"./component/form/formRules": [
		37118,
		9,
		7118
	],
	"./component/form/formRules.js": [
		37118,
		9,
		7118
	],
	"./component/layout/FooterLayout": [
		59494,
		9
	],
	"./component/layout/FooterLayout.js": [
		59494,
		9
	],
	"./component/layout/FooterText": [
		5023,
		9
	],
	"./component/layout/FooterText.tsx": [
		5023,
		9
	],
	"./component/layout/NavMenuLayout": [
		59143,
		9
	],
	"./component/layout/NavMenuLayout.module.css": [
		62483,
		9
	],
	"./component/layout/NavMenuLayout.tsx": [
		59143,
		9
	],
	"./component/other/HttpButton": [
		80429,
		9,
		7690,
		3913,
		429
	],
	"./component/other/HttpButton.tsx": [
		80429,
		9,
		7690,
		3913,
		429
	],
	"./component/pure/AbbrNoWrap": [
		24937,
		9,
		4937
	],
	"./component/pure/AbbrNoWrap.jsx": [
		24937,
		9,
		4937
	],
	"./component/pure/HighlightText": [
		98166,
		9,
		5785
	],
	"./component/pure/HighlightText.tsx": [
		98166,
		9,
		5785
	],
	"./component/pure/ShowIf": [
		79797,
		9,
		9797
	],
	"./component/pure/ShowIf.tsx": [
		79797,
		9,
		9797
	],
	"./helper/enums": [
		95135,
		9
	],
	"./helper/enums.js": [
		95135,
		9
	],
	"./helper/functions": [
		16972,
		9
	],
	"./helper/functions.js": [
		16972,
		9
	],
	"./helper/tableColumn": [
		115,
		9,
		115
	],
	"./helper/tableColumn.tsx": [
		115,
		9,
		115
	],
	"./hooks/useGlobalData": [
		75925,
		9
	],
	"./hooks/useGlobalData.ts": [
		75925,
		9
	],
	"./hooks/useHttpService": [
		28028,
		9
	],
	"./hooks/useHttpService.ts": [
		28028,
		9
	],
	"./hooks/useLifecycledObserver": [
		60784,
		9,
		784
	],
	"./hooks/useLifecycledObserver.ts": [
		60784,
		9,
		784
	],
	"./hooks/usePagedQueryService": [
		5254,
		9,
		9212,
		5254
	],
	"./hooks/usePagedQueryService.ts": [
		5254,
		9,
		9212,
		5254
	],
	"./index": [
		36724,
		9
	],
	"./index.css": [
		59555,
		9
	],
	"./index.tsx": [
		36724,
		9
	],
	"./logo.svg": [
		69445,
		1,
		9445
	],
	"./pages/AddEfmSlicesToMaterialRepository": [
		49371,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		7914,
		3639,
		3840,
		4045,
		9371
	],
	"./pages/AddEfmSlicesToMaterialRepository.tsx": [
		49371,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		7914,
		3639,
		3840,
		4045,
		9371
	],
	"./pages/AdminManageMaterialRepository": [
		22400,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		2400
	],
	"./pages/AdminManageMaterialRepository.tsx": [
		22400,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		2400
	],
	"./pages/AdminManageResearchProject": [
		94469,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7914,
		4469
	],
	"./pages/AdminManageResearchProject.tsx": [
		94469,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7914,
		4469
	],
	"./pages/AssignLabelingTask": [
		47021,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		3639,
		3840,
		4045,
		7021
	],
	"./pages/AssignLabelingTask.tsx": [
		47021,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		3639,
		3840,
		4045,
		7021
	],
	"./pages/Common.module.css": [
		78186,
		9,
		8186
	],
	"./pages/EditMaterialDraft": [
		51655,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		4628,
		7942
	],
	"./pages/EditMaterialDraft.tsx": [
		51655,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		4628,
		7942
	],
	"./pages/EfmDataGroupAndLabelScheme": [
		57342,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7914,
		7342
	],
	"./pages/EfmDataGroupAndLabelScheme.tsx": [
		57342,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7914,
		7342
	],
	"./pages/EfmLabelingBoard": [
		47195,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		7914,
		8831,
		9005,
		7692,
		6766,
		3945,
		3840,
		5586,
		216
	],
	"./pages/EfmLabelingBoard.module.css": [
		13687,
		9,
		3687
	],
	"./pages/EfmLabelingBoard.tsx": [
		47195,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		7914,
		8831,
		9005,
		7692,
		6766,
		3945,
		3840,
		5586,
		216
	],
	"./pages/EfmLabelingDiff": [
		57698,
		9,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		3840,
		6804,
		7591
	],
	"./pages/EfmLabelingDiff.tsx": [
		57698,
		9,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		3840,
		6804,
		7591
	],
	"./pages/EfmLabelingMgmt": [
		40088,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		3639,
		3840,
		5708,
		88
	],
	"./pages/EfmLabelingMgmt.tsx": [
		40088,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		3639,
		3840,
		5708,
		88
	],
	"./pages/EfmResearchProject": [
		27055,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7055
	],
	"./pages/EfmResearchProject.tsx": [
		27055,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7055
	],
	"./pages/EfmResearchProjectMembers": [
		54994,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		4994
	],
	"./pages/EfmResearchProjectMembers.tsx": [
		54994,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		4994
	],
	"./pages/Home": [
		49954,
		9,
		9073,
		3650,
		9954
	],
	"./pages/Home.module.css": [
		46764,
		9,
		6764
	],
	"./pages/Home.tsx": [
		49954,
		9,
		9073,
		3650,
		9954
	],
	"./pages/Login": [
		32398,
		9,
		9073,
		8166,
		324
	],
	"./pages/Login.module.css": [
		7446,
		9,
		7446
	],
	"./pages/Login.tsx": [
		32398,
		9,
		9073,
		8166,
		324
	],
	"./pages/ManageGlobalEfmData": [
		24621,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		3639,
		3840,
		4045,
		4621
	],
	"./pages/ManageGlobalEfmData.tsx": [
		24621,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		3639,
		3840,
		4045,
		4621
	],
	"./pages/MaterialDataMgmt": [
		33707,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		7692,
		3840,
		3707
	],
	"./pages/MaterialDataMgmt.tsx": [
		33707,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		7692,
		3840,
		3707
	],
	"./pages/MaterialDetails": [
		52336,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		8117,
		2534
	],
	"./pages/MaterialDetails.tsx": [
		52336,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		8117,
		2534
	],
	"./pages/MaterialRepository": [
		67000,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7000
	],
	"./pages/MaterialRepository.tsx": [
		67000,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7000
	],
	"./pages/MaterialRepositoryMembers": [
		12031,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		2031
	],
	"./pages/MaterialRepositoryMembers.tsx": [
		12031,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		2031
	],
	"./pages/MobileAuth": [
		155,
		9,
		6491,
		155
	],
	"./pages/MobileAuth.tsx": [
		155,
		9,
		6491,
		155
	],
	"./pages/MobileLogin": [
		33130,
		9,
		6491,
		3130
	],
	"./pages/MobileLogin.tsx": [
		33130,
		9,
		6491,
		3130
	],
	"./pages/MobileRegister": [
		10120,
		9,
		9212,
		7690,
		3913,
		5213,
		6371,
		6712,
		8734
	],
	"./pages/MobileRegister.tsx": [
		10120,
		9,
		9212,
		7690,
		3913,
		5213,
		6371,
		6712,
		8734
	],
	"./pages/MobileSubmitPhoto": [
		73217,
		9,
		9212,
		7690,
		5213,
		6371,
		6712,
		7692,
		6491,
		7970,
		986,
		3217
	],
	"./pages/MobileSubmitPhoto.tsx": [
		73217,
		9,
		9212,
		7690,
		5213,
		6371,
		6712,
		7692,
		6491,
		7970,
		986,
		3217
	],
	"./pages/QueryAdmissionRecords": [
		25732,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		7914,
		3639,
		3840,
		4045,
		5732
	],
	"./pages/QueryAdmissionRecords.tsx": [
		25732,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		7914,
		3639,
		3840,
		4045,
		5732
	],
	"./pages/QueryLabelBoards": [
		48406,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		4561,
		7914,
		3639,
		3840,
		8406
	],
	"./pages/QueryLabelBoards.tsx": [
		48406,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		4561,
		7914,
		3639,
		3840,
		8406
	],
	"./pages/ResearchDataImportFromDataset": [
		17711,
		9,
		9212,
		8424,
		6497,
		9073,
		349,
		7711
	],
	"./pages/ResearchDataImportFromDataset.tsx": [
		17711,
		9,
		9212,
		8424,
		6497,
		9073,
		349,
		7711
	],
	"./pages/ResearchDataImportFromFCIS": [
		61022,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		7914,
		3639,
		3840,
		4045,
		1022
	],
	"./pages/ResearchDataImportFromFCIS.tsx": [
		61022,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		7914,
		3639,
		3840,
		4045,
		1022
	],
	"./pages/ResearchDataMgmt": [
		42431,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		3639,
		3840,
		4045,
		2431
	],
	"./pages/ResearchDataMgmt.tsx": [
		42431,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		3639,
		3840,
		4045,
		2431
	],
	"./pages/TakePhotoHistory": [
		20986,
		9,
		9212,
		8424,
		6497,
		5213,
		9154,
		4522,
		8605
	],
	"./pages/TakePhotoHistory.tsx": [
		20986,
		9,
		9212,
		8424,
		6497,
		5213,
		9154,
		4522,
		8605
	],
	"./pages/TakePhotos": [
		6929,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		4561,
		7970,
		730,
		6929
	],
	"./pages/TakePhotos.tsx": [
		6929,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		4561,
		7970,
		730,
		6929
	],
	"./pages/Users": [
		59483,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6766,
		8166,
		4217,
		9483
	],
	"./pages/Users.tsx": [
		59483,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6766,
		8166,
		4217,
		9483
	],
	"./pages/Workbench": [
		70185,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		4073,
		7332,
		3840,
		9902,
		6196
	],
	"./pages/Workbench.tsx": [
		70185,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		4073,
		7332,
		3840,
		9902,
		6196
	],
	"./pages/WorkbenchOfReviewer": [
		85114,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		6048,
		3840,
		3771,
		1899
	],
	"./pages/WorkbenchOfReviewer.tsx": [
		85114,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		6048,
		3840,
		3771,
		1899
	],
	"./pages/WorkloadStats": [
		94475,
		9,
		9212,
		8424,
		6497,
		5213,
		9073,
		9154,
		6603,
		4522,
		4561,
		1394
	],
	"./pages/WorkloadStats.tsx": [
		94475,
		9,
		9212,
		8424,
		6497,
		5213,
		9073,
		9154,
		6603,
		4522,
		4561,
		1394
	],
	"./react-app-env.d": [
		55059,
		7,
		5059
	],
	"./react-app-env.d.ts": [
		55059,
		7,
		5059
	],
	"./reportWebVitals": [
		16469,
		9,
		6469
	],
	"./reportWebVitals.ts": [
		16469,
		9,
		6469
	],
	"./routers/PageRoute.d": [
		28829,
		9,
		8829
	],
	"./routers/PageRoute.d.ts": [
		28829,
		9,
		8829
	],
	"./routers/navigations": [
		57651,
		9
	],
	"./routers/navigations.tsx": [
		57651,
		9
	],
	"./routers/router": [
		51606,
		9
	],
	"./routers/router.ts": [
		51606,
		9
	],
	"./setupTests": [
		35374,
		9,
		2012,
		1405,
		5374
	],
	"./setupTests.ts": [
		35374,
		9,
		2012,
		1405,
		5374
	],
	"App": [
		49816,
		9
	],
	"App.css": [
		44050,
		9
	],
	"App.test": [
		20477,
		9,
		2012,
		6004,
		477
	],
	"App.test.tsx": [
		20477,
		9,
		2012,
		6004,
		477
	],
	"App.tsx": [
		49816,
		9
	],
	"assets/background.jpeg": [
		31477,
		1,
		1477
	],
	"assets/city-road.svg": [
		36786,
		1,
		6786
	],
	"assets/doctor.svg": [
		77519,
		1,
		7519
	],
	"assets/efm_segment.svg": [
		49214,
		1,
		9214
	],
	"assets/persion.svg": [
		87544,
		1,
		7544
	],
	"assets/reply.svg": [
		36378,
		1,
		6378
	],
	"assets/ticker.svg": [
		56156,
		1,
		6156
	],
	"component/PagePreCheck": [
		5272,
		9
	],
	"component/PagePreCheck.tsx": [
		5272,
		9
	],
	"component/biz/AdmissionInfoModal": [
		93840,
		9,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		370
	],
	"component/biz/AdmissionInfoModal.tsx": [
		93840,
		9,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		370
	],
	"component/biz/CopyLabelingBoardModal": [
		45708,
		9,
		8424,
		6497,
		7690,
		3913,
		2513,
		5708,
		1423
	],
	"component/biz/CopyLabelingBoardModal.tsx": [
		45708,
		9,
		8424,
		6497,
		7690,
		3913,
		2513,
		5708,
		1423
	],
	"component/biz/EfmChart": [
		97168,
		9,
		7168
	],
	"component/biz/EfmChart.tsx": [
		97168,
		9,
		7168
	],
	"component/biz/EfmTimeOverviewModal": [
		94045,
		9,
		8424,
		7690,
		3913,
		9073,
		9923,
		4045,
		6560
	],
	"component/biz/EfmTimeOverviewModal.tsx": [
		94045,
		9,
		8424,
		7690,
		3913,
		9073,
		9923,
		4045,
		6560
	],
	"component/biz/EfmTimeSimplifiedModal": [
		76888,
		9,
		7690,
		3913,
		9073,
		6089
	],
	"component/biz/EfmTimeSimplifiedModal.tsx": [
		76888,
		9,
		7690,
		3913,
		9073,
		6089
	],
	"component/biz/LabelerWorkbenchAudited": [
		73760,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		3760
	],
	"component/biz/LabelerWorkbenchAudited.tsx": [
		73760,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		3760
	],
	"component/biz/LabelerWorkbenchLabeling": [
		65614,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		7332,
		3840,
		5614
	],
	"component/biz/LabelerWorkbenchLabeling.tsx": [
		65614,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		7332,
		3840,
		5614
	],
	"component/biz/LabelerWorkbenchNotReadyForAudit": [
		49902,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		4073,
		3840,
		9902,
		460
	],
	"component/biz/LabelerWorkbenchNotReadyForAudit.tsx": [
		49902,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		4073,
		3840,
		9902,
		460
	],
	"component/biz/LabelerWorkbenchReadyForAudit": [
		6673,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		3840,
		6673
	],
	"component/biz/LabelerWorkbenchReadyForAudit.tsx": [
		6673,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		3840,
		6673
	],
	"component/biz/LabelerWorkbenchWaittingAudit": [
		25062,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		5062
	],
	"component/biz/LabelerWorkbenchWaittingAudit.tsx": [
		25062,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		5062
	],
	"component/biz/LabelingBoard": [
		85586,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		7914,
		8831,
		9005,
		7692,
		6766,
		3945,
		3840,
		5586,
		6978
	],
	"component/biz/LabelingBoard.module.css": [
		80476,
		9,
		476
	],
	"component/biz/LabelingBoard.tsx": [
		85586,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		7914,
		8831,
		9005,
		7692,
		6766,
		3945,
		3840,
		5586,
		6978
	],
	"component/biz/LabelingBoardChartView": [
		49279,
		9,
		9279
	],
	"component/biz/LabelingBoardChartView.tsx": [
		49279,
		9,
		9279
	],
	"component/biz/LabelingDiff": [
		79221,
		9,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		3840,
		6804,
		4597
	],
	"component/biz/LabelingDiff.tsx": [
		79221,
		9,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		3840,
		6804,
		4597
	],
	"component/biz/LabelingTaskHistoryModal": [
		95880,
		9,
		7690,
		3913,
		5529
	],
	"component/biz/LabelingTaskHistoryModal.tsx": [
		95880,
		9,
		7690,
		3913,
		5529
	],
	"component/biz/MaterialBoard": [
		38117,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		8117,
		4121
	],
	"component/biz/MaterialBoard.module.css": [
		60021,
		9,
		21
	],
	"component/biz/MaterialBoard.tsx": [
		38117,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		8117,
		4121
	],
	"component/biz/MaterialChart": [
		65529,
		9,
		7910
	],
	"component/biz/MaterialChart.tsx": [
		65529,
		9,
		7910
	],
	"component/biz/MaterialDraft": [
		24628,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		4628,
		6856
	],
	"component/biz/MaterialDraft.module.css": [
		99894,
		9,
		9894
	],
	"component/biz/MaterialDraft.tsx": [
		24628,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		4628,
		6856
	],
	"component/biz/MaterialInfoModal": [
		92842,
		9,
		7690,
		3913,
		8839
	],
	"component/biz/MaterialInfoModal.tsx": [
		92842,
		9,
		7690,
		3913,
		8839
	],
	"component/biz/MaterialRepositorySelector": [
		19918,
		9,
		9212,
		8424,
		6497,
		9073,
		9918
	],
	"component/biz/MaterialRepositorySelector.tsx": [
		19918,
		9,
		9212,
		8424,
		6497,
		9073,
		9918
	],
	"component/biz/ResearchAndDataGroupAndLabelSchemeSelector": [
		31568,
		9,
		9212,
		8424,
		6497,
		9073,
		1568
	],
	"component/biz/ResearchAndDataGroupAndLabelSchemeSelector.tsx": [
		31568,
		9,
		9212,
		8424,
		6497,
		9073,
		1568
	],
	"component/biz/ResearchAndDataGroupSelector": [
		79990,
		9,
		9212,
		8424,
		6497,
		9073,
		9990
	],
	"component/biz/ResearchAndDataGroupSelector.tsx": [
		79990,
		9,
		9212,
		8424,
		6497,
		9073,
		9990
	],
	"component/biz/ReviewerWorkbenchNotReviewed": [
		20206,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		3840,
		206
	],
	"component/biz/ReviewerWorkbenchNotReviewed.tsx": [
		20206,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		3840,
		206
	],
	"component/biz/ReviewerWorkbenchOthersWaitingAudit": [
		57055,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		9436
	],
	"component/biz/ReviewerWorkbenchOthersWaitingAudit.tsx": [
		57055,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		3840,
		9436
	],
	"component/biz/ReviewerWorkbenchReviewed": [
		63771,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		6048,
		3840,
		3771,
		8079
	],
	"component/biz/ReviewerWorkbenchReviewed.tsx": [
		63771,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		6048,
		3840,
		3771,
		8079
	],
	"component/biz/UnlimitedResearchAndDataGroupAndLabelSchemeSelector": [
		98403,
		9,
		9212,
		8424,
		6497,
		9073,
		8403
	],
	"component/biz/UnlimitedResearchAndDataGroupAndLabelSchemeSelector.tsx": [
		98403,
		9,
		9212,
		8424,
		6497,
		9073,
		8403
	],
	"component/form/FormModal": [
		60834,
		9,
		9212,
		7690,
		3913,
		834
	],
	"component/form/FormModal.tsx": [
		60834,
		9,
		9212,
		7690,
		3913,
		834
	],
	"component/form/OptionalItem": [
		72982,
		9,
		9212,
		2513,
		2982
	],
	"component/form/OptionalItem.tsx": [
		72982,
		9,
		9212,
		2513,
		2982
	],
	"component/form/SchemaForm": [
		71816,
		9,
		5213,
		6371,
		2513,
		4561,
		7914,
		9434
	],
	"component/form/SchemaForm.tsx": [
		71816,
		9,
		5213,
		6371,
		2513,
		4561,
		7914,
		9434
	],
	"component/form/SearchForm": [
		66225,
		9,
		9212,
		6225
	],
	"component/form/SearchForm.tsx": [
		66225,
		9,
		9212,
		6225
	],
	"component/form/Selector": [
		25452,
		9,
		8424,
		6497,
		1757
	],
	"component/form/Selector.tsx": [
		25452,
		9,
		8424,
		6497,
		1757
	],
	"component/form/formItemLayout": [
		90104,
		9,
		104
	],
	"component/form/formItemLayout.js": [
		90104,
		9,
		104
	],
	"component/form/formRules": [
		37118,
		9,
		7118
	],
	"component/form/formRules.js": [
		37118,
		9,
		7118
	],
	"component/layout/FooterLayout": [
		59494,
		9
	],
	"component/layout/FooterLayout.js": [
		59494,
		9
	],
	"component/layout/FooterText": [
		5023,
		9
	],
	"component/layout/FooterText.tsx": [
		5023,
		9
	],
	"component/layout/NavMenuLayout": [
		59143,
		9
	],
	"component/layout/NavMenuLayout.module.css": [
		62483,
		9
	],
	"component/layout/NavMenuLayout.tsx": [
		59143,
		9
	],
	"component/other/HttpButton": [
		80429,
		9,
		7690,
		3913,
		429
	],
	"component/other/HttpButton.tsx": [
		80429,
		9,
		7690,
		3913,
		429
	],
	"component/pure/AbbrNoWrap": [
		24937,
		9,
		4937
	],
	"component/pure/AbbrNoWrap.jsx": [
		24937,
		9,
		4937
	],
	"component/pure/HighlightText": [
		98166,
		9,
		5785
	],
	"component/pure/HighlightText.tsx": [
		98166,
		9,
		5785
	],
	"component/pure/ShowIf": [
		79797,
		9,
		9797
	],
	"component/pure/ShowIf.tsx": [
		79797,
		9,
		9797
	],
	"helper/enums": [
		95135,
		9
	],
	"helper/enums.js": [
		95135,
		9
	],
	"helper/functions": [
		16972,
		9
	],
	"helper/functions.js": [
		16972,
		9
	],
	"helper/tableColumn": [
		115,
		9,
		115
	],
	"helper/tableColumn.tsx": [
		115,
		9,
		115
	],
	"hooks/useGlobalData": [
		75925,
		9
	],
	"hooks/useGlobalData.ts": [
		75925,
		9
	],
	"hooks/useHttpService": [
		28028,
		9
	],
	"hooks/useHttpService.ts": [
		28028,
		9
	],
	"hooks/useLifecycledObserver": [
		60784,
		9,
		784
	],
	"hooks/useLifecycledObserver.ts": [
		60784,
		9,
		784
	],
	"hooks/usePagedQueryService": [
		5254,
		9,
		9212,
		5254
	],
	"hooks/usePagedQueryService.ts": [
		5254,
		9,
		9212,
		5254
	],
	"index": [
		36724,
		9
	],
	"index.css": [
		59555,
		9
	],
	"index.tsx": [
		36724,
		9
	],
	"logo.svg": [
		69445,
		1,
		9445
	],
	"pages/AddEfmSlicesToMaterialRepository": [
		49371,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		7914,
		3639,
		3840,
		4045,
		9371
	],
	"pages/AddEfmSlicesToMaterialRepository.tsx": [
		49371,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		7914,
		3639,
		3840,
		4045,
		9371
	],
	"pages/AdminManageMaterialRepository": [
		22400,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		2400
	],
	"pages/AdminManageMaterialRepository.tsx": [
		22400,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		2400
	],
	"pages/AdminManageResearchProject": [
		94469,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7914,
		4469
	],
	"pages/AdminManageResearchProject.tsx": [
		94469,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7914,
		4469
	],
	"pages/AssignLabelingTask": [
		47021,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		3639,
		3840,
		4045,
		7021
	],
	"pages/AssignLabelingTask.tsx": [
		47021,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		3639,
		3840,
		4045,
		7021
	],
	"pages/Common.module.css": [
		78186,
		9,
		8186
	],
	"pages/EditMaterialDraft": [
		51655,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		4628,
		7942
	],
	"pages/EditMaterialDraft.tsx": [
		51655,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		4628,
		7942
	],
	"pages/EfmDataGroupAndLabelScheme": [
		57342,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7914,
		7342
	],
	"pages/EfmDataGroupAndLabelScheme.tsx": [
		57342,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7914,
		7342
	],
	"pages/EfmLabelingBoard": [
		47195,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		7914,
		8831,
		9005,
		7692,
		6766,
		3945,
		3840,
		5586,
		216
	],
	"pages/EfmLabelingBoard.module.css": [
		13687,
		9,
		3687
	],
	"pages/EfmLabelingBoard.tsx": [
		47195,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		7914,
		8831,
		9005,
		7692,
		6766,
		3945,
		3840,
		5586,
		216
	],
	"pages/EfmLabelingDiff": [
		57698,
		9,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		3840,
		6804,
		7591
	],
	"pages/EfmLabelingDiff.tsx": [
		57698,
		9,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		3840,
		6804,
		7591
	],
	"pages/EfmLabelingMgmt": [
		40088,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		3639,
		3840,
		5708,
		88
	],
	"pages/EfmLabelingMgmt.tsx": [
		40088,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		3639,
		3840,
		5708,
		88
	],
	"pages/EfmResearchProject": [
		27055,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7055
	],
	"pages/EfmResearchProject.tsx": [
		27055,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7055
	],
	"pages/EfmResearchProjectMembers": [
		54994,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		4994
	],
	"pages/EfmResearchProjectMembers.tsx": [
		54994,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		4994
	],
	"pages/Home": [
		49954,
		9,
		9073,
		3650,
		9954
	],
	"pages/Home.module.css": [
		46764,
		9,
		6764
	],
	"pages/Home.tsx": [
		49954,
		9,
		9073,
		3650,
		9954
	],
	"pages/Login": [
		32398,
		9,
		9073,
		8166,
		324
	],
	"pages/Login.module.css": [
		7446,
		9,
		7446
	],
	"pages/Login.tsx": [
		32398,
		9,
		9073,
		8166,
		324
	],
	"pages/ManageGlobalEfmData": [
		24621,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		3639,
		3840,
		4045,
		4621
	],
	"pages/ManageGlobalEfmData.tsx": [
		24621,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		3639,
		3840,
		4045,
		4621
	],
	"pages/MaterialDataMgmt": [
		33707,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		7692,
		3840,
		3707
	],
	"pages/MaterialDataMgmt.tsx": [
		33707,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		7692,
		3840,
		3707
	],
	"pages/MaterialDetails": [
		52336,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		8117,
		2534
	],
	"pages/MaterialDetails.tsx": [
		52336,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		8831,
		9005,
		3840,
		8117,
		2534
	],
	"pages/MaterialRepository": [
		67000,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7000
	],
	"pages/MaterialRepository.tsx": [
		67000,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		7000
	],
	"pages/MaterialRepositoryMembers": [
		12031,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		2031
	],
	"pages/MaterialRepositoryMembers.tsx": [
		12031,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		2031
	],
	"pages/MobileAuth": [
		155,
		9,
		6491,
		155
	],
	"pages/MobileAuth.tsx": [
		155,
		9,
		6491,
		155
	],
	"pages/MobileLogin": [
		33130,
		9,
		6491,
		3130
	],
	"pages/MobileLogin.tsx": [
		33130,
		9,
		6491,
		3130
	],
	"pages/MobileRegister": [
		10120,
		9,
		9212,
		7690,
		3913,
		5213,
		6371,
		6712,
		8734
	],
	"pages/MobileRegister.tsx": [
		10120,
		9,
		9212,
		7690,
		3913,
		5213,
		6371,
		6712,
		8734
	],
	"pages/MobileSubmitPhoto": [
		73217,
		9,
		9212,
		7690,
		5213,
		6371,
		6712,
		7692,
		6491,
		7970,
		986,
		3217
	],
	"pages/MobileSubmitPhoto.tsx": [
		73217,
		9,
		9212,
		7690,
		5213,
		6371,
		6712,
		7692,
		6491,
		7970,
		986,
		3217
	],
	"pages/QueryAdmissionRecords": [
		25732,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		7914,
		3639,
		3840,
		4045,
		5732
	],
	"pages/QueryAdmissionRecords.tsx": [
		25732,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		7914,
		3639,
		3840,
		4045,
		5732
	],
	"pages/QueryLabelBoards": [
		48406,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		4561,
		7914,
		3639,
		3840,
		8406
	],
	"pages/QueryLabelBoards.tsx": [
		48406,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		4561,
		7914,
		3639,
		3840,
		8406
	],
	"pages/ResearchDataImportFromDataset": [
		17711,
		9,
		9212,
		8424,
		6497,
		9073,
		349,
		7711
	],
	"pages/ResearchDataImportFromDataset.tsx": [
		17711,
		9,
		9212,
		8424,
		6497,
		9073,
		349,
		7711
	],
	"pages/ResearchDataImportFromFCIS": [
		61022,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		7914,
		3639,
		3840,
		4045,
		1022
	],
	"pages/ResearchDataImportFromFCIS.tsx": [
		61022,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		7914,
		3639,
		3840,
		4045,
		1022
	],
	"pages/ResearchDataMgmt": [
		42431,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		3639,
		3840,
		4045,
		2431
	],
	"pages/ResearchDataMgmt.tsx": [
		42431,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		349,
		4561,
		3639,
		3840,
		4045,
		2431
	],
	"pages/TakePhotoHistory": [
		20986,
		9,
		9212,
		8424,
		6497,
		5213,
		9154,
		4522,
		8605
	],
	"pages/TakePhotoHistory.tsx": [
		20986,
		9,
		9212,
		8424,
		6497,
		5213,
		9154,
		4522,
		8605
	],
	"pages/TakePhotos": [
		6929,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		4561,
		7970,
		730,
		6929
	],
	"pages/TakePhotos.tsx": [
		6929,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		4561,
		7970,
		730,
		6929
	],
	"pages/Users": [
		59483,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6766,
		8166,
		4217,
		9483
	],
	"pages/Users.tsx": [
		59483,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6766,
		8166,
		4217,
		9483
	],
	"pages/Workbench": [
		70185,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		4073,
		7332,
		3840,
		9902,
		6196
	],
	"pages/Workbench.tsx": [
		70185,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		4073,
		7332,
		3840,
		9902,
		6196
	],
	"pages/WorkbenchOfReviewer": [
		85114,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		6048,
		3840,
		3771,
		1899
	],
	"pages/WorkbenchOfReviewer.tsx": [
		85114,
		9,
		9212,
		8424,
		6497,
		7690,
		3913,
		5213,
		9073,
		6371,
		2513,
		6712,
		9154,
		9923,
		6603,
		6273,
		6993,
		4522,
		349,
		6048,
		3840,
		3771,
		1899
	],
	"pages/WorkloadStats": [
		94475,
		9,
		9212,
		8424,
		6497,
		5213,
		9073,
		9154,
		6603,
		4522,
		4561,
		1394
	],
	"pages/WorkloadStats.tsx": [
		94475,
		9,
		9212,
		8424,
		6497,
		5213,
		9073,
		9154,
		6603,
		4522,
		4561,
		1394
	],
	"react-app-env.d": [
		55059,
		7,
		5059
	],
	"react-app-env.d.ts": [
		55059,
		7,
		5059
	],
	"reportWebVitals": [
		16469,
		9,
		6469
	],
	"reportWebVitals.ts": [
		16469,
		9,
		6469
	],
	"routers/PageRoute.d": [
		28829,
		9,
		8829
	],
	"routers/PageRoute.d.ts": [
		28829,
		9,
		8829
	],
	"routers/navigations": [
		57651,
		9
	],
	"routers/navigations.tsx": [
		57651,
		9
	],
	"routers/router": [
		51606,
		9
	],
	"routers/router.ts": [
		51606,
		9
	],
	"setupTests": [
		35374,
		9,
		2012,
		1405,
		5374
	],
	"setupTests.ts": [
		35374,
		9,
		2012,
		1405,
		5374
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 28969;
module.exports = webpackAsyncContext;